import { i18n } from '../../libs/i18n';

export default value =>
  typeof value === 'undefined' || value === null || value === ''
    ? i18n.t('form.error.required', 'Required')
    : undefined;
